// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "4497ca7c4c67027e0ab408d670474e5c" + ".css";
};